import {createApi, fetchBaseQuery} from "@reduxjs/toolkit/query/react";

export const jobsApi = createApi({
  reducerPath: "jobs/api",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_URL_DEVELOP}`,
    // baseUrl: `https://customer-api.techsbookdemo.com/api/v1`,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("techsbook_customer_portal_token");
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
        headers.set("time", String(Date.now()));
      }

      return headers;
    },
  }),
  keepUnusedDataFor: 0.0001,
  endpoints: (build) => ({
    getJobs: build.query({
      query: (params) => ({
        url: `/jobs/index?${params}`,
        method: "GET",
      }),
    }),
    getJobForms: build.mutation({
      query: (params) => ({
        url: `/jobs/job-forms?${params}`,
        method: "GET",
      }),
    }),
    getExcel: build.mutation({
      query: (params) => ({
        url: `/jobs/job-forms/export?${params}`,
        method: "GET",
        responseType: 'blob',
      }),
    }),
    getJobsStatuses: build.query({
      query: () => ({
        url: `/jobs/statuses`,
        method: "GET",
      }),
    }),
    getJobById: build.query({
      query: (title) => ({
        url: `/jobs/details/${title}`,
        method: "GET",
      }),
    }),
    getJobFormById: build.query({
      query: (params) => ({
        url: `/jobs/${params?.jobId}/form/${params?.formId ? params?.formId : ''}`,
        method: "GET",
      }),
    }),
    rateTechnician: build.query({
      query: ({params, body}) => ({
        url: `/jobs/${params}/rate-quality`,
        method: "POST",
        body: body
      }),
    }),
    cancelJob: build.query({
      query: (params) => ({
        url: `/jobs/${params}/cancel`,
        method: "POST",
      }),
    }),
    getTypeOfServices: build.query({
      query: (product_id) => ({
        url: `jobs/services/${product_id}`,
        method: "GET",
      }),
    }),
    addJobLineItems: build.query({
      query: ({id, body} ) => ({
        url: `jobs/${id}/add-line-item`,
        method: "POST",
        body,
        formData: true,
      }),
    }),
    editJobDescription: build.query({
      query: ({id, body} ) => ({
        url: `/jobs/${id}/update-description`,
        method: "POST",
        body,
        formData: true,
      }),
    }),
    editJobPrimaryContact: build.query({
      query: ({id, body} ) => ({
        url: `/jobs/${id}/update-primary-contact`,
        method: "POST",
        body,
        formData: true,
      }),
    }),
  }),
});

export const {
  useLazyGetJobsStatusesQuery,
  useLazyGetJobsQuery,
  useLazyGetJobByIdQuery,
  useLazyGetJobFormByIdQuery,
  useLazyRateTechnicianQuery,
  useGetJobFormsMutation,
  useLazyCancelJobQuery,
  useGetExcelMutation,
  useLazyGetTypeOfServicesQuery,
  useLazyAddJobLineItemsQuery,
  useLazyEditJobDescriptionQuery,
  useLazyEditJobPrimaryContactQuery,
} = jobsApi;
